import React, { useState, useEffect } from "react";
import { Column, DataGrid, Paging, Pager } from "devextreme-react/data-grid";
import { Editing } from "devextreme-react/scheduler";
import List from "devextreme-react/list";
import { criarSituacaoDividaDs, loadOrigens } from "../DataSources";
import uiInfo from "../ui-info";
import Form, { SimpleItem, Label, GroupItem } from "devextreme-react/form";
import { Button, ScrollView } from "devextreme-react";
import ContribuinteBox from "./contribuintes/ContribuinteBox";
import ImovelBox from "./imovel/ImovelBox";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import apiAxios from "../api-axios";
import UserInfo from "../UserInfo";
import PaginaToolbar from "../components/PaginaToolbar";

const AcompanhamentoDiatBox = ({ onSelecionado }) => {
  const [origensItems, setOrigensItems] = useState([]);

  useEffect(() => {
    loadOrigens()
      .load()
      .then((result) => {
        setOrigensItems(result);
      });
  }, []);

  const [filtersData, setFilterData] = useState({
    exercicioInicio: undefined,
    exercicioFinal: undefined,
    codigoInterno: undefined,
    imovel: undefined,
    situacaoImovel: -2,
    naturezaTributaria: 0,
    contribuinteId: undefined,
    nomeContribuinte: undefined,
    tipoDeData: 0,
    dataInicio: undefined,
    dataFinal: undefined,
    codigoNegociacao: undefined,
    popupContribuinteVisivel: false,
    popupImovelVisivel: false,
  });
  const [diatGrid, setDiatGrid] = useState([]);
  const [situacoes, setSituacoes] = useState([]);
  const [origens, setOrigens] = useState([]);

  const contribuinteBoxRef = React.createRef();
  function onContribuinteSelecionadoPesquisa(e) {
    setFilterData({
      ...filtersData,
      contribuinteId: e.row.data.sequencial,
      exibirPesqContribuinte: false,
    });
  }

  const imovelBoxRef = React.createRef();
  function onImovelSelecionadoPesquisa(e) {
    setFilterData({
      ...filtersData,
      imovel: e.row.data.sequencial,
      popupImovelVisivel: false,
    });
  }

  async function filtrar() {
    let filtros = { ...filtersData, origens, situacoesDividas: situacoes };

    const response = await apiAxios.post(
      "diat/start_grade_diat/" + UserInfo.getPrefeitura(),
      filtros
    );
    setDiatGrid(response.data);
  }

  function retornaSelectBox(datasource, expressao, showClearButton) {
    const show = showClearButton == undefined ? true : showClearButton;
    return {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: datasource,
      valueExpr: "id",
      displayExpr: expressao,
      showClearButton: show,
    };
  }

  function renderSituacoes() {
    return (
      <div
        style={{
          borderStyle: "solid",
          borderWidth: "1px",
          borderColor: "lightgray",
        }}
      >
        <List
          dataSource={criarSituacaoDividaDs()}
          height={130}
          showSelectionControls={true}
          selectionMode="multiple"
          displayExpr="nome"
          selectedItems={situacoes}
          showBorders={true}
          onOptionChanged={(e) => {
            if (e.name === "selectedItems") {
              setSituacoes(e.value);
            }
          }}
        ></List>
      </div>
    );
  }

  function renderOrigens() {
    return (
      <div
        style={{
          borderStyle: "solid",
          borderWidth: "1px",
          borderColor: "lightgray",
        }}
      >
        <List
          items={origensItems}
          height={130}
          showSelectionControls={true}
          selectionMode="multiple"
          selectedItems={origens}
          onOptionChanged={(e) => {
            if (e.name === "selectedItems") {
              setOrigens(e.value);
            }
          }}
        ></List>
      </div>
    );
  }

  function limparFiltro() {
    setDiatGrid([]);
    setFilterData({});
    setFilterData({ situacaoImovel: -2, naturezaTributaria: 0, tipoDeData: 0 });
    setOrigens([]);
    setSituacoes([]);
  }

  return (
    <div className={"content-block dx-card responsive-paddings"}>
      <h3>DÉBITOS DA DÍVIDA ATIVA</h3>
      <br />
      <form onSubmit={() => filtrar()}>
        <Form
          id="frmPesquisa"
          formData={filtersData}
          colCount={10}
          labelLocation={"top"}
        >
          <GroupItem colCount={4} colSpan={6}>
            <SimpleItem dataField="codigoInterno" colSpan={1}>
              <Label text="Código Interno" />
            </SimpleItem>
            <SimpleItem dataField="exercicioInicio" colSpan={1}>
              <Label text="Início do Exercício" />
            </SimpleItem>
            <SimpleItem dataField="exercicioFinal" colSpan={1}>
              <Label text="Fim do Exercício" />
            </SimpleItem>

            <SimpleItem
              dataField="imovel"
              editorOptions={{
                buttons: [
                  {
                    name: "Pesquisar",
                    location: "after",
                    options: {
                      stylingMode: "text",
                      icon: "search",
                      onClick: () => {
                        setFilterData({
                          ...filtersData,
                          popupImovelVisivel: true,
                        });
                      },
                    },
                  },
                ],
              }}
              colSpan={1}
            >
              <Label text="Inscrição do Imóvel" />
            </SimpleItem>
            <SimpleItem
              colSpan={2}
              dataField="situacaoImovel"
              editorType={"dxSelectBox"}
              editorOptions={retornaSelectBox(
                [
                  { id: -2, descricao: "Todas" },
                  { id: -1, descricao: "Pendente" },
                  { id: 0, descricao: "Gerada" },
                  { id: 1, descricao: "Em Execução" },
                  { id: 2, descricao: "Cancelada" },
                  { id: 3, descricao: "Protestando" },
                  { id: 4, descricao: "Protestada" },
                ],
                "descricao",
                false
              )}
            >
              <Label text="Situação Execução" />
            </SimpleItem>
            <SimpleItem
              colSpan={4}
              dataField="naturezaTributaria"
              editorType={"dxSelectBox"}
              editorOptions={retornaSelectBox(
                [
                  { id: 0, descricao: "Todas" },
                  { id: 1, descricao: "Tributária" },
                  { id: 2, descricao: "Não Tributária" },
                ],
                "descricao",
                false
              )}
              
            >
              <Label text="Natureza Tributária" />
            </SimpleItem>
            <SimpleItem
              dataField="contribuinteId"
              editorOptions={{
                buttons: [
                  {
                    name: "Pesquisar",
                    location: "after",
                    options: {
                      stylingMode: "text",
                      icon: "search",
                      onClick: () => {
                        setFilterData({
                          ...filtersData,
                          popupContribuinteVisivel: true,
                        });
                      },
                    },
                  },
                ],
              }}
              colSpan={1}
            >
              <Label text="Inscrição do Contribuinte" />
            </SimpleItem>
            <SimpleItem
              dataField="tipoDeData"
              editorType={"dxSelectBox"}
              editorOptions={retornaSelectBox(
                [
                  { id: 0, descricao: " " },
                  { id: 1, descricao: "Vencimento" },
                  { id: 2, descricao: "Pagamento" },
                  { id: 3, descricao: "Crédito" },
                  { id: 4, descricao: "Inscrição" },
                  { id: 5, descricao: "Negociação" },
                ],
                "descricao",
                false
              )}
            >
              <Label text="Tipo de Data" />
            </SimpleItem>
            <SimpleItem
              dataField="dataInicio"
              editorType={"dxDateBox"}
              editorOptions={{ width: "100%" }}
            >
              <Label text="Data do Início" />
            </SimpleItem>
            <SimpleItem
              dataField="dataFinal"
              editorType={"dxDateBox"}
              editorOptions={{ width: "100%" }}
            >
              <Label text="Data do Fim" />
            </SimpleItem>
            <SimpleItem dataField="codigoNegociacao">
              <Label text="Código da Negociação" />
            </SimpleItem>
          </GroupItem>

          <SimpleItem colSpan={3} render={renderSituacoes}>
            <Label text="Situações" />
          </SimpleItem>

          <SimpleItem colSpan={1} render={renderOrigens}>
            <Label text="Origens" />
          </SimpleItem>
        </Form>

        <div
          style={{
            marginTop: "30px",
            display: "flex",
            justifyContent: "left",
          }}
        >
          <div style={{ display: "inline-block" }}>
            <Button
              width={120}
              text="Filtrar"
              type="success"
              onClick={() => filtrar()}
            />
          </div>
          <div style={{ display: "inline-block", marginLeft: "10px" }}>
            <Button text="Limpar Filtro" onClick={() => limparFiltro()} />
          </div>
        </div>
      </form>
      <br />

      <PaginaToolbar ocultarNovo={true} titulo={"Lista de Resultados"}>
        <DataGrid
          dataSource={diatGrid}
          showBorders={true}
          rowAlternationEnabled={true}
          remoteOperations={true}
          columnChooser={{ enabled: true }}
          columnAutoWidth={true}
        >
          <Editing
            mode={"row"}
            allowAdding={false}
            allowUpdating={false}
            allowDeleting={false}
            useIcons={true}
          />
          {onSelecionado && (
            <Column
              type="buttons"
              width={60}
              buttons={[
                {
                  icon: "repeat",
                  visible: onSelecionado != undefined,
                  onClick: onSelecionado
                },
              ]}
            />
          )}
          <Column dataField={"tipo"} caption={"Tipo"} width={120} />
          <Column dataField={"codigoInterno"} caption={"#"} width={100} />
          <Column dataField={"natureza"} caption={"Natureza"} width={120} />
          <Column dataField={"situacao"} caption={"Situação"} width={170} />
          <Column dataField={"exercicio"} caption={"Exercício"} width={80} />
          <Column
            dataField={"livro"}
            caption={"Livro"}
            visible={false}
            width={80}
          />
          <Column
            dataField={"folha"}
            caption={"Folha"}
            visible={false}
            width={80}
          />
          <Column
            dataField={"ordem"}
            caption={"Ordem"}
            visible={false}
            width={80}
          />
          <Column dataField={"origem"} caption={"Origem"} width={80} />
          <Column dataField={"parcela"} caption={"Parcela"} width={80} />
          <Column
            dataField={"vencimento"}
            caption={"Vencimento"}
            dataType={"date"}
            width={100}
          />
          <Column
            dataField={"dataInscricao"}
            caption={"Dt. Inscrição"}
            visible={false}
            width={100}
          />
          <Column
            dataField={"valor"}
            caption={"Valor"}
            dataType={"number"}
            format={uiInfo.formatoNumerico.n2}
            width={120}
          />
          <Column
            dataField={"seqImovel"}
            caption={"Cód. Imóvel"}
            visible={true}
            width={120}
          />
          <Column
            dataField={"seqContribuinte"}
            caption={"Cód. Contribuinte"}
            visible={true}
            width={150}
          />
          <Column dataField={"documento"} caption={"Documento"} width={130} />
          <Column dataField={"contribuinte"} caption={"Contribuinte"} />
          <Column
            dataField={"tipoDocumento"}
            caption={"Contribuinte"}
            visible={false}
          />

          <Column
            dataField={"negociacao"}
            caption={"Negociação"}
            visible={false}
          />
          <Column dataField={"processo"} caption={"Processo"} visible={false} />
          <Column dataField={"acordao"} caption={"Acordão"} visible={false} />

          <Column dataFinal={"enderecoImovel"} caption={"Endereço Imóvel"} visible={false} />

          <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
          <Pager
            showPageSizeSelector={true}
            allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
          />
        </DataGrid>
      </PaginaToolbar>

      <Popup
        visible={filtersData.popupContribuinteVisivel}
        onHiding={() =>
          setFilterData({ ...filtersData, popupContribuinteVisivel: false })
        }
        dragEnabled={false}
        closeOnOutsideClick={false}
        showCloseButton={false}
        showTitle={true}
        width={"90%"}
        height={"90%"}
        title="Pesquisar Contribuinte"
      >
        <ScrollView showScrollbar={"always"}>
          <ContribuinteBox
            onSelecionado={onContribuinteSelecionadoPesquisa}
            ref={contribuinteBoxRef}
          />
        </ScrollView>
        <ToolbarItem
          toolbar={"bottom"}
          widget="dxButton"
          location="center"
          options={{
            text: "Fechar",
            type: "default",
            width: 150,
            onClick: () =>
              setFilterData({
                ...filtersData,
                popupContribuinteVisivel: false,
              }),
          }}
        ></ToolbarItem>
      </Popup>
      <Popup
        visible={filtersData.popupImovelVisivel}
        onHiding={() =>
          setFilterData({ ...filtersData, popupImovelVisivel: false })
        }
        dragEnabled={false}
        closeOnOutsideClick={false}
        showCloseButton={false}
        showTitle={true}
        width={"90%"}
        height={"90%"}
        title="Pesquisar Imóvel"
      >
        <ScrollView showScrollbar={"always"}>
          <ImovelBox
            onSelecionado={onImovelSelecionadoPesquisa}
            ref={imovelBoxRef}
          />
        </ScrollView>
        <ToolbarItem
          toolbar={"bottom"}
          widget="dxButton"
          location="center"
          options={{
            text: "Fechar",
            type: "default",
            width: 150,
            onClick: () =>
              setFilterData({ ...filtersData, popupImovelVisivel: false }),
          }}
        ></ToolbarItem>
      </Popup>
    </div>
  );
};

export default AcompanhamentoDiatBox;
